module.exports = __webpack_public_path__ + "static/media/open_access.abe24066.svg";